import React from "react";
import { FrameContext } from "../../contexts/FrameContext";

const TextToggle = (props) => {
  const { settings } = React.useContext(FrameContext);

  const onCheckboxChange = (e) => {
    props.onChange(e.target.checked, e.target.value);
  };

  const getBorderStyle = () => {
    if (!settings || !settings.styles || !settings.styles.buttonBorderRadius) return null;
    return { borderRadius: settings.styles.buttonBorderRadius };
  };

  const getSelectedStyle = () => {
    if (!settings || !settings.styles || (!settings.styles.buttonBorderRadius && !settings.styles.primaryColor)) return null;

    let styles = {};
    // if (settings.styles.buttonBorderRadius) {
    //     styles.borderRadius = settings.styles.buttonBorderRadius;
    // }

    // if (settings.styles.primaryColor) {
    //     styles.backgroundColor = settings.styles.primaryColor;
    // }

    // if (settings.styles.secondaryTextColor) {
    //     styles.color = settings.styles.secondaryTextColor;
    // }

    if (settings.styles.primaryColor) {
      styles.borderColor = settings.styles.primaryColor;
    }

    return styles;
  };

  return (
    <div className="radio-group cts-text-toggle" /*style={getBorderStyle()}*/>
      <div className="radio-wrapper">
        <input
          onChange={onCheckboxChange}
          type="radio"
          autoFocus={props.value === props.r2Text}
          tabIndex="0"
          name="question"
          value={props.r2Text}
          id="r2"
          className="sr-only"
          checked={props.value === props.r2Text}
        />
        <label style={props.value === props.r2Text ? getSelectedStyle() : {}} htmlFor="r2">
          {props.r2Text}
        </label>
      </div>
      <div className="radio-wrapper">
        <input
          onChange={onCheckboxChange}
          type="radio"
          autoFocus={props.value === props.r1Text}
          tabIndex="0"
          name="question"
          value={props.r1Text}
          id="r1"
          className="sr-only"
          checked={props.value === props.r1Text}
        />
        <label style={props.value === props.r1Text ? getSelectedStyle() : {}} htmlFor="r1">
          {props.r1Text}
        </label>
      </div>
      <div className="radio-wrapper" style={settings && settings.lang && settings.lang === "fr" ? { width: "200px" } : {}}>
        <input
          onChange={onCheckboxChange}
          type="radio"
          autoFocus={props.value === props.r3Text}
          tabIndex="0"
          name="question"
          value={props.r3Text}
          id="r3"
          className="sr-only"
          checked={props.value === props.r3Text}
        />
        <label style={props.value === props.r3Text ? getSelectedStyle() : {}} htmlFor="r3">
          {props.r3Text}
        </label>
      </div>
    </div>
  );
};

export default TextToggle;
